import React from "react";
import PageHeaderLayout from "../../../../layout/pageHeaderLayout";
import StandardTable, {StandardColumnsType} from "../../../../components/StandardTable";
import useAntTable from "../../../../utils/useAntTable";
import * as api from "../../../../apis/platforms/admin/company";
import ModifyModal from "./modifyModal";
import useFormModal from "../../../../utils/useFormModal";
import {Button, Space} from "antd";


function Company() {

    const {tableProps, refresh} = useAntTable(api.getCompanies, {})

    const {modalProps, setVisible} = useFormModal({
        onRequest: api.modifyCompany,
        onOk: () => {
            refresh()
            setVisible(false)
        }
    })

    const columns: StandardColumnsType = [
        {
            title: '编号',
            dataIndex: 'code'
        },
        {
            title: '名称',
            dataIndex: 'name'
        },
        {
            title: 'OA ID',
            dataIndex: 'oaId'
        },
        {
            title: '赠品与样品叠加限制',
            dataIndex: 'noRepeatGiveaway',
            render: (enable: boolean) => enable ? '是' : '否'
        },
        {
            title: '操作',
            dataIndex: 'operations',
            render: (_, record: any) => (
                <span>
                    <a onClick={() => setVisible(true, record)}>编辑</a>
                </span>
            )
        }
    ]

    return (
        <PageHeaderLayout>
            <StandardTable rowKey={'id'} columns={columns} {...tableProps} toolbar={(
                <Space>
                    <Button type={'primary'} onClick={() => setVisible(true)}>新增</Button>
                </Space>
            )}/>
            <ModifyModal {...modalProps} />
        </PageHeaderLayout>
    )
}

export default Company
